<template>
  <el-dialog title="编辑自动回复规则" :visible.sync="dialogVisible" @close="$emit('update:visible',false)"
             :close-on-click-modal="closeModal">
    <div class="dialog_conwrap">
      <el-form ref="form" label-width="200px" label-position="left">
        <el-form-item label="自动回复：(随机发送)">
          <div class="common_wrap" v-if="form.data.length!==0">
            <div class="common_item common_getList" v-for="(item, index) in form.data" :key="index">
              <div class="common_textarea_wrap common_getInfo" v-if="responseStatus[index]">
                <el-input class="common_textarea" type="textarea" rows="6" v-model="form.data[index].response"></el-input>
                <div class="common_textarea_action">
                  <el-button type="text" class="mr-10" @click="addUserName(index)">粉丝名称</el-button>
                  <!--<el-button type="text">插入链接</el-button>-->
                  <el-popover
                          placement="top"
                          width="300"
                          title="插入链接"
                          v-model="linevisible">
                    <el-input v-model="linkAdd" placeholder="https://"></el-input>
                    <div style="text-align: right; margin: 10px 0 0;">
                      <el-button size="mini" type="text" @click="linevisible = false">取消</el-button>
                      <el-button type="primary" size="mini" @click="lineaddTag(index)">添加</el-button>
                    </div>
                    <el-button type="text" slot="reference">插入链接</el-button>
                  </el-popover>
                </div>
              </div>
              <div class="common_getList_box" v-else @click.stop="takeLineIndex(index)">
                {{item.response}}
                <i class="iconfont iconguanbi common_getList_icon" @click.stop="detelLineFn(index)"></i>
              </div>
            </div>
          </div>
          <div class="comment_btn" @click="addReply">
            <span>
              <i class="el-icon-plus"></i>添加回复
            </span>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false" size="small">取 消</el-button>
      <el-button type="primary" @click="submitTagFn" size="small">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
  import api from "@/api.js";

  export default {
    name: "batchOpenDialog",
    props: ["visible", "editBody"],
    watch: {
      visible() {
        this.dialogVisible = this.visible;
      }
    },
    data() {
      return {
        dialogVisible: this.visible,
        form: {
          data: [], 	// 	varchar 	必填 	- 	- 	自动回复(数组)
        },
        responseStatus: [],
        closeModal: false,
        linevisible: false,
        linkAdd: ''
      };
    },
    created() {
      if (this.editBody.length!==0) {
        this.form.data= this.editBody;
        let responseStatus = [];
        for (let i in this.editBody) {
          if (i === 0) {
            responseStatus.push(true)
          } else {
            responseStatus.push(false)
          }
        }
        this.responseStatus = responseStatus
      }
    },
    methods: {
      // linevisible
      lineaddTag(index) {
        if (this.linkAdd) {
          this.form.data[index].response = this.form.data[index].response + ' https://' + this.linkAdd + ' ';
          this.linevisible = false
          this.linkAdd = ''
        } else {
          this.$message({
            message: '请填写链接',
            center: true,
            type: 'warning'
          });
        }
      },
      // 添加自动回复
      addReply() {
        this.form.data.push({response:''});
        for (let i in this.responseStatus) {
          this.responseStatus[i] = false
        }
        this.responseStatus.push(true)
      },
      takeLineIndex(index) {
        let list_ = [];
        for (let i in this.responseStatus) {
          let responseStatus = true
          if (Number(i) !== index) {
            responseStatus = false
          }
          list_.push(responseStatus)
        }
        this.responseStatus = list_
      },
      addUserName(index) {
        this.form.data[index].response = this.form.data[index].response + '#粉丝昵称#'
      },
      detelLineFn(index) {
        this.form.data.splice(index, 1);
        this.responseStatus.splice(index, 1)
      },
      submitTagFn() {
        if (this.form.data.length === 0) {
          this.messagebox('请添加回复')
          return
        } else {
          for (let i in this.form.data) {
            if (!this.form.data[i].response) {
              this.messagebox('请添加回复内容')
              return
            }
          }
        }
        // 进行提交
        this.axios
            .post(api.accounts_attention_set, this.form)
            .then(response => {
              if (response.data.code == 0) {
                this.$message({
                  message: '编辑成功',
                  center: true,
                });
                this.dialogVisible = false
                this.$emit('changeInint')
              } else {
              }
            })
            .catch(response => {
              this.lock = true;
            });
      },
      messagebox(title) {
        this.$message({
          message: title,
          center: true,
          type: 'warning'
        });
      }
    }
  };
</script>
